/* istanbul ignore next */
/**
 * This method replace the default price with regional price value
 * @static
 * @memberof RegionalPriceHelper
 */
export const populateRegionalPricesInContentData = (contentItems, regionZone) => {
    if (!contentItems) {
        return;
    }
    const selectedRegionZone = `r${regionZone}_data`;
    contentItems.forEach((item) => {
        if (regionZone && item.regionalDataMap) {
            const regionalItemData = item.regionalDataMap[selectedRegionZone] || {};
            Object.assign(item, regionalItemData);
        }
    });
};
/**
 * This method replace the default price with regional price value
 * @static
 * @memberof RegionalPriceHelper
 */
export const populateRegionalPricesInSuggestionProducts = (products, regionZone) => {
    if (!products) {
        return;
    }
    const selectedRegionZone = `r${regionZone}_data`;
    products.forEach((product) => {
        if (regionZone) {
            const regionalPrice = product[selectedRegionZone] || {};
            Object.assign(product, regionalPrice);
        }
    });
};

export default class RegionalPriceHelper {
    static populateRegionalPricesInContentData(contentItems, regionZone) {
        return populateRegionalPricesInContentData(contentItems, regionZone);
    }

    static populateRegionalPricesInSuggestionProducts(products, regionZone) {
        return populateRegionalPricesInSuggestionProducts(products, regionZone);
    }
}
